import mitt from 'mitt'

/**
 * Application event bus.
 *
 * The previous implementation used a Vue 2 instance (`new Vue()`) and relied on
 * the instance `$on/$off/$emit` methods, which were removed in Vue 3. This is a
 * drop-in replacement backed by `mitt` that keeps the exact same public surface
 * (`EventBus.$on/$off/$once/$emit` and the `eh` helper), so no call sites need
 * to change.
 */
const emitter = mitt()

export const EventBus = {
  $on(type, handler) {
    emitter.on(type, handler)
  },
  $off(type, handler) {
    emitter.off(type, handler)
  },
  $once(type, handler) {
    const wrapped = (e) => {
      emitter.off(type, wrapped)
      handler(e)
    }
    emitter.on(type, wrapped)
  },
  $emit(type, event) {
    emitter.emit(type, event)
  },
}

var m = {}

class eventhandler {
  on(name, handler) {
    if (m[name] == undefined) {
      m[name] = true
    } else {
      emitter.off(name)
    }
    emitter.on(name, handler)
  }

  off(name) {
    emitter.off(name)
  }
}

export const eh = new eventhandler()
